<template>
  <StatCard
    :icon="require(`@/assets/images/icon-waiting_time.svg`)"
    :loading="onlineExtensionsCountLoading"
    :error="onlineExtensionsCountErrorMessage"
    @retry="fetchOnlineExtensionsCount"
  >
    <template #head>
      <div class="d-flex flex-column align-items-center">
        <p class="m-0">
          {{ $t('dashboard.statistics.extensions.online-extensions-count') }}
        </p>
        <h3 class="m-0">
          {{
            onlineExtensionsCount +
              ' ' +
              $t('dashboard.statistics.extensions.extension')
          }}
        </h3>
      </div>
    </template>
    <template #foot>
      <p class="m-0 text-center">
        {{ $t('dashboard.statistics.extensions.total-online-extensions') }}
      </p>
    </template>
  </StatCard>
</template>
<script>
import StatCard from '../../elements/StatCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    StatCard
  },
  computed: {
    ...mapGetters([
      'onlineExtensionsCount',
      'onlineExtensionsCountLoading',
      'onlineExtensionsCountErrorMessage'
    ])
  },
  methods: {
    ...mapActions(['fetchOnlineExtensionsCount'])
  },
  mounted() {
    this.fetchOnlineExtensionsCount()
  }
}
</script>
<style lang="sass" scoped></style>
